module.exports = __webpack_public_path__ + "img/leads_active.5abf8458.svg";